import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private apiUrl = environment.apiRoot;

  constructor(private http: HttpClient) { }

  fileUpload(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(this.apiUrl + '/file/upload', formData);
  }

  fileDownloadFixedPathBlob(fileName: string): Observable<Blob> {
    return this.http.get(this.apiUrl + '/file/download/' + fileName, { responseType: 'blob' });
  }

  fileDownloadFixedPath(fileName: string): Observable<ArrayBuffer> {
    return this.http.get(this.apiUrl + '/file/download/' + fileName, { responseType: 'arraybuffer' });
  }

  fileDownloadGeneral(filePath: string): Observable<ArrayBuffer> {
    return this.http.get(this.apiUrl + filePath, { responseType: 'arraybuffer' });
  }

  fileDownloadGeneralBlob(filePath: string): Observable<Blob> {
    return this.http.get(this.apiUrl + filePath, { responseType: 'blob' });
  }

  arrayBufferToBase64(buffer: ArrayBuffer): string {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    let str = window.btoa(binary);
    let imgStr = `data:image/jpeg;base64,${str}`;
    return imgStr;
  }

  /**
   * Trigger the file-saving action of the browser
   * @param blob the content of file as a blob (binary)
   * @param fileName full file name in string
   */
  saveAs(blob: Blob, fileName: string) {

    //1. create a new anchor element (<a>) and set its download attribute to the desired filename. 
    const link = document.createElement('a');

    //2. then create a URL object with the createObjectURL() method and set the href attribute of the anchor element to the URL.
    link.download = fileName;
    link.href = URL.createObjectURL(blob);

    //3. programmatically click the anchor element to trigger the file download. 
    link.click();

    //4. Finally, revoke the URL object with the revokeObjectURL() method to free up memory.
    window.URL.revokeObjectURL(link.href);
  }

}
